// @ts-nocheck
import getQueryString from "@store/Framework/Common/Utilities/getQueryString";
import { useLocation } from "@store/Framework/Store/Data/Pages/PageHooks";
import { ParametersOmitFirst } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

const useQueryString = <T>(...args: ParametersOmitFirst<typeof getQueryString>) => {
    const location = useLocation();

    return useMemo(() => {
        return getQueryString<T>(location.search, ...args);
    }, [location.search]);
};

export default useQueryString;
